import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  static LANG_CACHE_KEY: string = "IOP_Language";

  static LANG_SR_CYRL_RS: string = "sr-Cyrl-RS";
  static LANG_SR_LATN: string = "sr-Latin-RS";

  constructor() { }
}
